const isValidAppClient = (client: unknown): client is 'eig' | 'ryze' =>
  client === 'eig' || client === 'ryze'

const APP_CLIENT_PRE =
  isValidAppClient(import.meta.env.VITE_APP_CLIENT) && import.meta.env.VITE_APP_CLIENT
if (!APP_CLIENT_PRE) throw new Error('VITE_APP_CLIENT should be `eig` or `ryze`')

export const APP_CLIENT = APP_CLIENT_PRE
